// src/pages/micuenta/Facturacion.jsx
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowLeft, FaFileInvoiceDollar } from "react-icons/fa";
import "./facturacion.css";

function Facturacion() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!user) {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Cargando usuario...</h2>
        </div>
      </div>
    );
  }

  // Ejemplo de facturas (estos datos podrían provenir de una API)
  const facturas = [
    {
      id: 1,
      fecha: "30 de Octubre de 2024",
      mes: "Octubre 2024",
      linkDescarga: "#",
    },
    {
      id: 2,
      fecha: "15 de Noviembre de 2024",
      mes: "Noviembre 2024",
      linkDescarga: "#",
    },
  ];

  return (
    <div className="register-container">
      <div className="register-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={() => navigate("/mi-cuenta")}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>

        {/* Encabezado de Facturación */}
        <h2 className="facturacion-title">
          <FaFileInvoiceDollar className="section-icon" /> Facturación
        </h2>

        {/* Cabecera del listado */}
        <div className="facturacion-header">
          <span className="factura-col fecha-col">FACTURA</span>
          <span className="factura-col mes-col">MES</span>
          <span className="factura-col accion-col">ACCIÓN</span>
        </div>

        {/* Listado de facturas */}
        {facturas.map((factura) => (
          <div className="factura-row" key={factura.id}>
            <span className="factura-col fecha-col">{factura.fecha}</span>
            <span className="factura-col mes-col">{factura.mes}</span>
            <button
              className="factura-descargar-btn"
              onClick={() =>
                alert(`Descargando la factura del ${factura.mes}`)
              }
            >
              Descargar
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Facturacion;